import React from 'react'
import * as S from './styled'

const Certification = ({url, image}) => {

  return (
      <>
      <img src={image} />
      <S.CertificationLink
        data-testid="footer-certified"
        href={url}
      >
        Clique aqui
      </S.CertificationLink>{' '}
      para acessar todos certificados
    </>
  )
}

export default Certification
